import { c as _c } from "react/compiler-runtime";
import { InlineAlert } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import AnimatedContainer from '@/components/animated-container';
import type { TransformedDocument } from '@/components/entities/components/details/hooks/use-documents';
import type useEntityVault from '@/components/entities/hooks/use-entity-vault';
import useSession from '@/hooks/use-session';
import AgentExtractionData from './components/agent-extraction-data';
import AiImageScores from './components/ai-image-scores';
import ConfidenceScores from './components/confidence-scores';
import ExtractedDocumentData from './components/extracted-document-data';
import FaceChecks from './components/face-checks';
import IdentityData from './components/identity-data';
import RawJsonData from './components/raw-json-data';
import useAgentExtractionResult from './hooks/use-agent-extraction-result';
export type DrawerContentProps = {
  document: TransformedDocument;
  vault: ReturnType<typeof useEntityVault>;
};
const DrawerContent = t0 => {
  const $ = _c(41);
  const {
    document,
    vault
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.documents.details"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    data: session
  } = useSession();
  const isFirmEmployee = !!session.user?.isFirmEmployee;
  const {
    extractions,
    hasExtractionData
  } = useAgentExtractionResult(document.id);
  const isFixtureData = document.fixtureResult && document.fixtureResult !== "real";
  let t2;
  if ($[1] !== vault.data?.vault) {
    t2 = vault.data?.vault || {};
    $[1] = vault.data?.vault;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const vaultData = t2;
  let t3;
  if ($[3] !== document.completedVersion) {
    t3 = document.completedVersion?.toString();
    $[3] = document.completedVersion;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const activeDocumentVersion = t3;
  const similarity = document.faceComparison?.similarity;
  const faceMatchScore = typeof similarity === "number" ? Math.floor(similarity * 10) / 10 : undefined;
  let t4;
  if ($[5] !== isFixtureData || $[6] !== t) {
    t4 = isFixtureData && <InlineAlert variant="info">{t(_temp)}</InlineAlert>;
    $[5] = isFixtureData;
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = isFirmEmployee ? faceMatchScore : undefined;
  let t6;
  if ($[8] !== document || $[9] !== t5) {
    t6 = <ConfidenceScores document={document} faceMatchScore={t5} />;
    $[8] = document;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== document.faceComparison || $[12] !== document.faceDetection || $[13] !== isFirmEmployee) {
    t7 = isFirmEmployee && <FaceChecks detection={document.faceDetection} comparison={document.faceComparison} />;
    $[11] = document.faceComparison;
    $[12] = document.faceDetection;
    $[13] = isFirmEmployee;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== document.uploads) {
    t8 = <AiImageScores uploads={document.uploads} />;
    $[15] = document.uploads;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== extractions || $[18] !== hasExtractionData) {
    t9 = hasExtractionData && <AgentExtractionData extractions={extractions} />;
    $[17] = extractions;
    $[18] = hasExtractionData;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== hasExtractionData || $[21] !== t9) {
    t10 = <AnimatedContainer isExpanded={hasExtractionData}>{t9}</AnimatedContainer>;
    $[20] = hasExtractionData;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const t11 = activeDocumentVersion ?? "";
  let t12;
  if ($[23] !== document.kind || $[24] !== t11 || $[25] !== vaultData) {
    t12 = <ExtractedDocumentData vault={vaultData} documentType={document.kind} activeDocumentVersion={t11} />;
    $[23] = document.kind;
    $[24] = t11;
    $[25] = vaultData;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== document) {
    t13 = <IdentityData document={document} />;
    $[27] = document;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== document || $[30] !== vaultData) {
    t14 = <RawJsonData vault={vaultData} document={document} />;
    $[29] = document;
    $[30] = vaultData;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t10 || $[33] !== t12 || $[34] !== t13 || $[35] !== t14 || $[36] !== t4 || $[37] !== t6 || $[38] !== t7 || $[39] !== t8) {
    t15 = <>{t4}{t6}{t7}{t8}{t10}{t12}{t13}{t14}</>;
    $[32] = t10;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
    $[36] = t4;
    $[37] = t6;
    $[38] = t7;
    $[39] = t8;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  return t15;
};
export default DrawerContent;
function _temp($) {
  return $.isFixtureAlert;
}